import { cellRenderPopupActM3 } from '../../PopupActMVP/functionPopupAct';
import { cellRenderParseData, cellRenderStatusAct } from '../../../utils/functions';

const columnDataAZH = [
  {
    dataField: 'mh3',
    caption: 'Акт о завершении хранения',
    cellRender: cellRenderPopupActM3,
    cssClass: 'td-button-cell-render',
    dataType: 'string'
  },
  {
    dataField: 'mh3NumId',
    caption: 'id АЗХ',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3DocStatus',
    caption: 'id АЗХ Doc Status',
    notVisible: true,
    dataType: 'number'
  },
  {
    dataField: 'mh3Date',
    caption: 'Дата акта о завершении хранения',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'mh3Status',
    caption: 'Выкуп акт о завершении хранения',
    dataType: 'string'
  },
  {
    dataField: 'azhStatusDescr',
    caption: 'Статус акта о завершении хранения',
    cellRender: cellRenderStatusAct,
    dataType: 'string'
  }
];
export default columnDataAZH;
